import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  
  constructor() {
   
  }
}



// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/app/app.component.ts